import type { RootStateType } from '../store'
import type { Auth, User } from './type'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type SetAuthUserPayload = {
  vendor: User
  token?: string
  isWelcomePopup: boolean
}

const initialState: Auth = {
  token: '',
  user: null,
  isWelcomePopup: true,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.token = initialState.token
      state.user = initialState.user
    },
    setAuthUser: (state, action: PayloadAction<SetAuthUserPayload>) => {
      state.user = action.payload.vendor
      if (action.payload.token) {
        state.token = action.payload.token
      }
    },
    setWelcome: (state, action: PayloadAction<boolean>) => {
      state.isWelcomePopup = action.payload
    },
  },
})

export const { setAuthUser, setWelcome } = authSlice.actions
export const resetAuth = authSlice.actions.reset

export const authSliceReducer = authSlice.reducer

export const selectUser = (state: RootStateType) => state.auth.user
